export default "__VITE_ASSET__BqFLDQf___"